
<script>
  import Layout from "./Layout.svelte";

  export let endpoint;

  let fetchBlocks = (async () => {
      const response = await fetch(endpoint);
      return await response.json();
  })();
</script>

{#await fetchBlocks}
<p>loading...</p>

{:then blocks}
<Layout blocks={blocks} />

{:catch error}
<p>Something went wrong: {error.message}</p>

{/await}
